import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

// Asegúrate de que las rutas a las imágenes sean las correctas en tu proyecto
import asesoraImg from "../../static/media/home/Asesora.webp";
import crisImg from "../../static/media/home/Cris.webp";

const C = {
  darkBlue: "#0C1F2F",
  navy: "#0057A8",
  gold: "#FFCD00",
  gray: "#F5F7FA",
  white: "#ffffff",
  teal: "#5BC8AF",
};

const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=593999943920&text=Hola+quiero+m%C3%A1s+informaci%C3%B3n&type=phone_number&app_absent=0";

export default function ContactoAsesora() {
  return (
    <Box
      id="contacto-asesora"
      sx={{
        background: C.white,
        pt: { xs: "80px", md: "100px" },
        pb: { xs: "80px", md: "100px" },
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          px: { xs: 3, sm: 5, md: 6 },
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 6, md: 4, lg: 8 },
          }}
        >
          {/* LADO IZQUIERDO: TEXTO Y MASCOTA (CRIS) */}
          <Box
            sx={{
              width: { xs: "100%", md: "45%" },
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", md: "flex-start" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <Typography
                variant="h2"
                sx={{
                  color: C.darkBlue,
                  fontWeight: 750,
                  fontSize: { xs: 28, sm: 34, md: 40 },
                  letterSpacing: "-.02em",
                  lineHeight: 1.1,
                  mb: 2,
                }}
              >
                Atención Personalizada
              </Typography>
              <Box
                sx={{
                  width: "45px",
                  height: "3px",
                  background: C.navy,
                  mx: { xs: "auto", md: 0 },
                  borderRadius: "2px",
                  mb: 3,
                }}
              />
              <Typography
                sx={{
                  color: "#5c6c7a",
                  fontSize: { xs: 15, md: 16 },
                  lineHeight: 1.6,
                  mb: { xs: 4, md: 4 }, // Aumentado para dar respiro al globo en móvil
                  maxWidth: "450px",
                }}
              >
                Jessenia está lista para brindarte el mejor soporte técnico y
                comercial para tus proyectos eléctricos.
              </Typography>
            </Box>

            {/* CONTENEDOR ANIMADO (Mascota + Globo de Texto flotan juntos) */}
            <Box
              component={motion.div}
              animate={{ y: [-6, 6, -6] }}
              transition={{
                y: { duration: 3.5, repeat: Infinity, ease: "easeInOut" },
              }}
              sx={{
                position: "relative",
                display: "inline-block",
                mt: { xs: 7, md: 4 }, // Aumentado en móvil (xs: 7) para empujar la mascota hacia abajo
                ml: { md: 4 },
              }}
            >
              {/* Globo de texto (Animación solo de entrada) */}
              <Box
                component={motion.div}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{
                  opacity: { duration: 0.6, delay: 0.3 },
                  scale: { duration: 0.6, type: "spring", delay: 0.3 },
                }}
                sx={{
                  position: "absolute",
                  top: { xs: "-40px", md: "-30px" },
                  right: { xs: "-20px", md: "-60px" },
                  background: C.gold,
                  color: C.darkBlue,
                  fontWeight: 800,
                  fontSize: "13px",
                  px: 2,
                  py: 1,
                  borderRadius: "16px 16px 16px 0",
                  boxShadow: "0 8px 15px rgba(255, 205, 0, 0.3)",
                  zIndex: 2,
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: "-6px",
                    left: "0px",
                    borderWidth: "8px 8px 0 0",
                    borderStyle: "solid",
                    borderColor: `${C.gold} transparent transparent transparent`,
                  },
                }}
              >
                ¡Haz clic en la tarjeta!
              </Box>

              {/* Imagen de la mascota (Animación solo de entrada) */}
              <Box
                component={motion.img}
                src={crisImg}
                alt="Cris Mascota Eléctrica GRM"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                sx={{
                  width: { xs: "180px", sm: "200px", md: "220px" },
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>

          {/* LADO DERECHO: TARJETA DE LA ASESORA (CLICKABLE) */}
          <Box
            component={motion.a}
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.02, rotate: -1 }}
            transition={{ duration: 0.6, type: "spring", bounce: 0.3 }}
            sx={{
              width: { xs: "100%", sm: "80%", md: "55%" },
              display: "flex",
              justifyContent: "center",
              position: "relative",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            {/* Elemento decorativo detrás de la tarjeta */}
            <Box
              sx={{
                position: "absolute",
                top: "10%",
                left: "-5%",
                width: "110%",
                height: "110%",
                background: `linear-gradient(135deg, ${C.gold}22 0%, ${C.navy}11 100%)`,
                borderRadius: "24px",
                transform: "rotate(-3deg)",
                zIndex: 0,
                transition: "transform 0.3s ease",
              }}
            />

            <Box
              component="img"
              src={asesoraImg}
              alt="Tarjeta Jessenia Cedeño"
              sx={{
                width: "100%",
                height: "auto",
                maxWidth: "600px",
                borderRadius: "16px",
                boxShadow: "0 20px 40px rgba(12, 31, 47, 0.15)",
                position: "relative",
                zIndex: 1,
                border: "4px solid white",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
